module.exports = __webpack_public_path__ + "img/dani-diez-untitled.6f6e4c5.jpg";